document.querySelector('.to-newsletter')?.addEventListener('click', () => {
  document.querySelector('.site-footer__newsletter')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

document
  .querySelectorAll('[data-back-btn]')
  .forEach((btn) => btn.addEventListener('click', () => (history.length > 1 ? history.back() : (location.href = '/'))));
